const RESPONSIVE_STATE_CHANGE = '@@responsive/STATE_CHANGE';

const defaultBreakpoints = {
  extraSmall: 480,
  small: 600,
  medium: 960,
  large: 1280,
  extraLarge: 1920,
};

const getResponsiveState = (breakpoints = defaultBreakpoints, width = 0) => {
  const entries = Object.entries(breakpoints);

  return entries.reduce(
    (state, [key, breakpoint]) => ({
      ...state,
      lessThan: {
        ...state.lessThan,
        [key]: width < breakpoint,
      },
      greaterThan: {
        ...state.greaterThan,
        [key]: width > breakpoint,
      },
      is: {
        ...state.is,
        [key]: width <= breakpoint,
      },
    }),
    {
      mediaType: 'screen',
      orientation: width > 0 && typeof window !== 'undefined' && window.innerHeight > window.innerWidth ? 'portrait' : 'landscape',
      lessThan: {},
      greaterThan: {},
      is: {},
    },
  );
};

const getWindowWidth = () => (typeof window !== 'undefined' ? window.innerWidth : 0);

export const createResponsiveStateReducer = breakpoints => {
  const initialState = getResponsiveState(breakpoints, getWindowWidth());

  return (state = initialState, action) => {
    if (action.type === RESPONSIVE_STATE_CHANGE) {
      return getResponsiveState(breakpoints, action.payload.width);
    }

    return state;
  };
};

export const responsiveStoreEnhancer = createStore => (...args) => {
  const store = createStore(...args);

  if (typeof window === 'undefined') {
    return store;
  }

  const dispatchResponsiveState = () => {
    store.dispatch({ type: RESPONSIVE_STATE_CHANGE, payload: { width: window.innerWidth } });
  };

  dispatchResponsiveState();
  window.addEventListener('resize', dispatchResponsiveState);

  return store;
};